const defaultValue = { images: {} }

export default defaultValue
